<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <cart-checkout-success v-if="checkout_successful" class="mt-5"></cart-checkout-success>
    <div v-else>
      <div class="mt-5 display-4 text-left">
        <span>Checkout</span>
<!--        <b-button variant="primary" size="sm" class="float-right" @click="fillForm">-->
<!--          <i class="fas fa-fill"></i>-->
<!--        </b-button>-->
      </div>
      <div>
        <b-card class="mt-3">
          <div v-if="authenticated_customer_contact_id">
            <div class="display-4 font-2xl mb-4">{{ authenticated_customer_contact_name }} ({{ authenticated_customer_name }})</div>
            <p class="text-muted"><i class="fal fa-map-marker"></i><span class="pl-2">Fill out your billing address below.</span></p>
          </div>
          <div v-else>
            <p class="text-muted">Let us know who you are.</p>
            <customer-contact-form-group
              :customer_contact="customer_contact"
              @onCustomerContactChange="onCustomerContactChange"
            ></customer-contact-form-group>
            <hr />
            <p class="text-muted"><i class="fal fa-building"></i><span class="pl-2">Tell us about your company.</span></p>
            <customer-form-group
              :customer="customer"
              @onCustomerChange="onCustomerChange"
            ></customer-form-group>
            <hr />
            <p class="text-muted"><i class="fal fa-map-marker"></i><span class="pl-2">Where is your company located?</span></p>
          </div>
          <customer-location-form-group
            :customer_location="customer_location"
            @onCustomerLocationChange="onCustomerLocationChange"
          ></customer-location-form-group>
          <!--<stripe-card-element></stripe-card-element>-->
        </b-card>
        <b-card>
          <div class="display-4 font-2xl mb-4">Would you like to pay electronically or receive an invoice?</div>
          <b-row>
            <b-col>
              <b-button :variant="(isCardPayment() ? 'success' : null)" @click="setPaymentMethod('card')" block>Pay Now</b-button>
            </b-col>
            <b-col>
              <b-button :variant="(isInvoicePayment() ? 'success' : null)" @click="setPaymentMethod('invoice')" block>Invoice Me</b-button>
            </b-col>
          </b-row>
        </b-card>
        <div v-if="isInvoicePayment()"></div>
        <div v-if="isCardPayment()">
          <b-card>
            <div class="display-4 font-2xl mb-4">Payment</div>
            <p class="text-muted"><i class="fal fa-credit-card"></i><span class="pl-2">Please fill out your payment information.</span></p>
<!--            <b-alert v-if="card_error" variant="danger" show style="font-size: 0.7rem;" class="p-2">{{card_error}}</b-alert>-->
<!--            <div ref="card"></div>-->
            <stripe-card-element></stripe-card-element>
          </b-card>
        </div>
      </div>
      <b-alert v-if="progress__error" variant="danger" show style="font-size: 0.7rem;" class="p-2 mb-4">{{progress__error}}</b-alert>
      <cart-checkout-process
        v-if="progress__show"
        :message="progress__message"
        :max="progress__max"
        :value="progress__value"
        class="mb-4"
      ></cart-checkout-process>
      <div class="clearfix mb-5">
        <b-button :disabled="submit_disabled" variant="success" class="float-right" @click="checkoutCart">Submit</b-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {CART_REMOVE_ITEM, CART_CLEAR_ITEMS, CART_CHECKOUT, AUTH_CREATE_GUEST} from "@/store/action-types"
  import {AUTH_SET_CUSTOMER_ID, AUTH_SET_CUSTOMER_NAME, AUTH_SET_CUSTOMER_CONTACT_ID, AUTH_SET_CUSTOMER_CONTACT_NAME} from "@/store/mutation-types"
  import CustomerContactFormGroup from "../../components/auth/register/inner/CustomerContactFormGroup";
  import CustomerFormGroup from "../../components/auth/register/inner/CustomerFormGroup";
  import CustomerLocationFormGroup from "../../components/auth/register/inner/CustomerLocationFormGroup";
  //import {CrmRepositoryFactory} from "@/repositories/crm/CrmRepositoryFactory";
  import CartCheckoutSuccess from "./CartCheckoutSuccess";
  import CartCheckoutProcess from "../../components/cart/CartCheckoutProcess";
  import StripeCardElement from "../../components/cart/StripeCardElement";
  import CustomerContactModel from "../../models/crm/CustomerContactModel";
  import CustomerModel from "../../models/crm/CustomerModel";
  import LoadingOverlay from "../../components/shared/LoadingOverlay";

  //const CustomersRepository = CrmRepositoryFactory.get('customers');

  // let stripe = null;
  // let card = null;
  // let elements = null;
  // if(window.Stripe === undefined) {
  //   console.error('Stripe V3 library not loaded!')
  // } else {
  //   stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
  //   elements = stripe.elements();
  // }

  export default {
    components: {
      LoadingOverlay,
      StripeCardElement,
      CartCheckoutProcess,
      CartCheckoutSuccess,
      CustomerLocationFormGroup,
      CustomerFormGroup,
      CustomerContactFormGroup},
    name: 'CartCheckout',
    data() {
      return {

        loading: true,

        items: this.$store.getters.getCartItems || [],

        authenticated: (this.$store.getters.isAuthenticated || false),
        authenticated_customer_contact_id: (this.$store.getters.getAuthCustomerContactID || null),
        authenticated_customer_contact_name: (this.$store.getters.getAuthCustomerContactName || null),
        authenticated_customer_id: (this.$store.getters.getAuthCustomerID || null),
        authenticated_customer_name: (this.$store.getters.getAuthCustomerName || null),

        customer_contact: null,
        customer_location: null,
        customer: null,

        customer_model: null,

        payment_required: false,
        payment_method: null,

        submit_disabled: false,

        stripe_config: null,

        progress__show: false,
        progress__message: null,
        progress__value: 0,
        progress__max: 5,
        progress__error: null,

        checkout_successful: false,

      }
    },
    methods: {

      /*isCreditAccount() {
        return this.customer && this.customer.credit && +(this.customer.credit);
      },*/

      isCardPayment() {
        return (this.payment_method === 'card');
      },

      isInvoicePayment() {
        return (this.payment_method === 'invoice');
      },

      setPaymentMethod(method) {
        this.payment_method = method;
      },

      fillForm: function () {

        let customer = this.$faker().company.companyName();
        this.customer = {
          short_name: customer.split(' ')[0],
          full_name: customer,
        };
        this.customer_contact = {
          first_name: this.$faker().name.firstName(),
          last_name: this.$faker().name.lastName(),
          phone_number: this.$faker().phone.phoneNumber(),
          email: null
          //email: email,
        };
        this.customer_location = {
          street_address: this.$faker().address.streetAddress(),
          city: this.$faker().address.city(),
          region: this.$faker().address.state(),
          country: this.$faker().address.country(),
          postal_code: this.$faker().address.zipCode(),
        };

      },

      onCustomerContactChange: function (customer_contact) {
        this.customer_contact = customer_contact;
      },
      onCustomerChange: function (customer) {
        this.customer = customer;
      },
      onCustomerLocationChange: function (customer_location) {
        this.customer_location = customer_location;
      },
      checkoutCart: function () {
        return new Promise((resolve, reject) => {
          if(this.authenticated && this.authenticated_customer_id) {
            this.markProcessing(1, 'Updating Customer');
            this.updateCustomer().then((customer_id) => {
              if(this.isCardPayment()) {
                this.markProcessing(2, 'Processing Payment');
                this.processCardPayment().then((invoice_id) => {
                  this.markProcessed();
                  resolve();
                });
              } else if(this.isInvoicePayment()) {
                this.markProcessing(2, 'Invoicing Customer');
                this.sendInvoice().then((invoice_id) => {
                  this.markProcessed();
                  resolve();
                });
              }
            });
          } else {
            this.markProcessing(1, 'Creating Guest');
            this.createGuest().then((user_id) => {
              this.customer_contact.user_id = user_id;
              this.markProcessing(2, 'Creating Customer');
              this.createCustomer().then((customer_id) => {
                if(this.isCardPayment()) {
                  this.markProcessing(3, 'Processing Payment');
                  this.processCardPayment().then((invoice_id) => {
                    this.markProcessed();
                    resolve();
                  });
                } else if(this.isInvoicePayment()) {
                  this.markProcessing(3, 'Invoicing Customer');
                  this.sendInvoice().then((invoice_id) => {
                    this.markProcessed();
                    resolve();
                  });
                }
              });
            });
          }
        });
        /*return;
        this.markProcessing(1, 'Validating Customer');
        this.createCustomer().then((customer) => {
          if(this.isCardPayment()) {
            this.markProcessing(2, 'Checking Card');
            if(window.stripeCardInstance) {
              this.markProcessing(3, 'Submitting Payment');
              let stripe = window.stripeCardInstance.stripe || null;
              let card = window.stripeCardInstance.card || null;
              stripe.createToken(card).then((result) => {
                if (result.error) {
                  this.setProcessingError(result.error.message);
                } else if (result.token) {
                  let token = result.token;
                  this.$store.dispatch(CART_CHECKOUT, {customer, token}).then(() => {
                    this.markProcessed(4, 'Finishing Up');
                    this.$store.dispatch(CART_CLEAR_ITEMS).then(() => {
                      this.markProcessed();
                    }, () => {
                      this.setProcessingError('Could not clear the cart');
                    });
                  }, () => {
                    this.setProcessingError('Could not create invoice');
                  });
                } else {
                  this.setProcessingError('Invalid Card');
                }
              });
            } else {
              this.setProcessingError('Could not create card instance');
            }
          } else if(this.isInvoicePayment()) {
            this.markProcessing(3, 'Submitting Invoice');
            this.$store.dispatch(CART_CHECKOUT, {customer, token: null}).then(() => {
              console.log('test');
              this.markProcessed(4, 'Finishing Up');
              this.$store.dispatch(CART_CLEAR_ITEMS).then(() => {
                this.markProcessed();
              }, () => {
                this.setProcessingError('Could not clear the cart');
              });
            }, () => {
              this.setProcessingError('Could not create invoice');
            });
          } else {
            this.setProcessingError('Payment method is required');
          }
        }, () => {
          this.setProcessingError('Invalid Customer');
        });*/
      },
      createCustomer: function() {
        return new Promise((resolve, reject) => {
          let payload = JSON.parse(JSON.stringify(this.customer)) || {};
          payload.customer_contacts = [JSON.parse(JSON.stringify(this.customer_contact))];
          payload.customer_locations = [JSON.parse(JSON.stringify(this.customer_location))];
          let customer = new CustomerModel(payload);
          customer.save().then(() => {
            this.customer_model = customer;
            this.$store.commit(AUTH_SET_CUSTOMER_ID, customer.id);
            this.$store.commit(AUTH_SET_CUSTOMER_NAME, customer.full_name);
            this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_ID, customer.customer_contacts[0].id);
            this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_NAME, customer.customer_contacts[0].name);
            resolve(customer.id);
          }, () => {
            reject();
          });
          /*if(this.authenticated_customer_contact_id) {
            let contact = new CustomerContactModel(this.authenticated_customer_contact_id);
            contact.fetch().then(() => {
              resolve(contact.getCustomer());
            });
          } else {
            let contact = new CustomerContactModel(JSON.parse(JSON.stringify(this.customer_contact)));
            contact.exists().then((result) => {
              if(result) {
                this.setProcessingError('The email ' + contact.email + ' is already in use.');
              } else {
                let payload = JSON.parse(JSON.stringify(this.customer)) || {};
                payload.customer_contacts = [JSON.parse(JSON.stringify(this.customer_contact))];
                payload.customer_locations = [JSON.parse(JSON.stringify(this.customer_location))];
                let customer = new CustomerModel(payload);
                customer.save().then(() => {
                  resolve(customer);
                }).catch(reject);
              }
            });
          }
           */
        });
      },
      updateCustomer: function() {
        console.log(this.customer);
        return new Promise((resolve, reject) => {
          this.customer_model = this.customer;
          this.$store.commit(AUTH_SET_CUSTOMER_ID, this.customer.id);
          this.$store.commit(AUTH_SET_CUSTOMER_NAME, this.customer.full_name);
          this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_ID, this.customer.customer_contacts[0].id);
          this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_NAME, this.customer.customer_contacts[0].name);
          resolve(this.customer.id);

        });
      },
      // updateCustomer: function() {

      //   console.log(this.customer);

      //   return new Promise((resolve, reject) => {
      //     let payload = JSON.parse(JSON.stringify(this.customer)) || {};
      //     payload.customer_contacts = [JSON.parse(JSON.stringify(this.customer_contact))];
      //     payload.customer_locations = [JSON.parse(JSON.stringify(this.customer_location))];
      //     let customer = new CustomerModel(payload);
      //     customer.save().then(() => {
      //       this.customer_model = customer;
      //       this.$store.commit(AUTH_SET_CUSTOMER_ID, customer.id);
      //       this.$store.commit(AUTH_SET_CUSTOMER_NAME, customer.full_name);
      //       this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_ID, customer.customer_contacts[0].id);
      //       this.$store.commit(AUTH_SET_CUSTOMER_CONTACT_NAME, customer.customer_contacts[0].name);
      //       resolve(customer.id);
      //     }).catch(reject);
      //   });
      // },
      createGuest: function () {
        return new Promise((resolve, reject) => {
          this.$store.dispatch(AUTH_CREATE_GUEST, {username: this.customer_contact.email, password: 'Password1!'}).then((response) => {
            // console.log('--------- CREATE GUEST SUCCESS');
            // console.log(response);
            // console.log(this.$store.getters.getAuthUserID);
            resolve(this.$store.getters.getAuthUserID);
          }, (response) => {
            this.setProcessingError(this.customer_contact.email + ' already exists');
            reject();
          });
        });
      },
      processCardPayment: function () {
        return new Promise((resolve, reject) => {
          let customer = this.customer_model;
          if(window.stripeCardInstance) {
            let stripe = window.stripeCardInstance.stripe || null;
            let card = window.stripeCardInstance.card || null;
            stripe.createToken(card).then((result) => {
              if (result.error) {
                this.setProcessingError(result.error.message);
              } else if (result.token) {
                let token = result.token;
                this.$store.dispatch(CART_CHECKOUT, {customer, token}).then(() => {
                  this.$store.dispatch(CART_CLEAR_ITEMS).then(() => {
                    resolve();
                  }, () => {
                    this.setProcessingError('Could not clear the cart');
                    reject();
                  });
                }, (msg) => {
                  this.setProcessingError(msg || 'Could not create invoice');
                  reject();
                });
              } else {
                this.setProcessingError('Invalid Card');
                reject();
              }
            });
          } else {
            this.setProcessingError('Could not create card instance');
            reject();
          }
        });
      },
      sendInvoice: function () {
        return new Promise((resolve, reject) => {
          let customer = this.customer_model;
          this.$store.dispatch(CART_CHECKOUT, {customer, token: null}).then(() => {
            this.$store.dispatch(CART_CLEAR_ITEMS).then(() => {
              resolve();
            }, () => {
              this.setProcessingError('Could not clear the cart');
              reject();
            });
          }, () => {
            this.setProcessingError('Could not create invoice');
            reject();
          });
        });
      },
      markProcessing(value, message) {
        this.submit_disabled = true;
        this.progress__show = true;
        this.progress__message = message;
        this.progress__value = value;
        this.progress__error = null;
      },
      setProcessingError(error) {
        this.submit_disabled = false;
        this.progress__show = false;
        this.progress__message = null;
        this.progress__value = 0;
        this.progress__error = error;
      },
      markProcessed() {
        this.$router.push('/cart/checkout/finalize');
        this.checkout_successful = true;
        this.submit_disabled = false;
        this.progress__show = false;
        this.progress__message = null;
        this.progress__value = 6;
        this.progress__error = null;
      }
    },
    mounted() {

      this.loading = true;
      let promises = [];
      let customer = null;
      if (this.authenticated_customer_id) {
        customer = new CustomerModel({id: this.authenticated_customer_id});
        promises.push(customer.fetch({ params: { connection: ['customer_locations'] } }));
      }
      let customer_contact = null;
      if (this.authenticated_customer_contact_id) {
        customer_contact = new CustomerContactModel({id: this.authenticated_customer_contact_id});
        promises.push(customer_contact.fetch());
      }
      Promise.all(promises).then(() => {
        if (customer_contact) {
          this.customer_contact = JSON.parse(JSON.stringify(customer_contact));
          if (this.customer_contact.customer_location && this.customer_contact.customer_location.id) {
            this.customer_location = this.customer_contact.customer_location;
          }
        }
        if (customer) {
          this.customer = customer;
          if (this.customer && +this.customer.credit) {
            this.setPaymentMethod('invoice');
          } else {
            this.setPaymentMethod('card');
          }
          if (!this.customer_location && this.customer.customer_locations && this.customer.customer_locations.length) {
            this.customer_location = this.customer.customer_locations[0];
          }
        }
        if (!this.customer && !this.customer_contact && !this.customer_location) {
          this.setPaymentMethod('card');
          if (this.$cookies.get('faker_enabled') === '1') {
            this.fillForm();
          }
        }
        this.loading = false;
      });

    }
  }
</script>
